import { createEntityAdapter, EntityId } from '@reduxjs/toolkit';
import {
  AndroidVersion,
  App,
  AppCategory, AppMarketPermission,
  DeveloperAppReview,
  GlobalAppCollection, MerchantPlan,
  ServerFeature, SuggestedApp,
} from '../../models/app';

export const appCollectionsAdapter = createEntityAdapter<GlobalAppCollection>();
export const appReviewsAdapter = createEntityAdapter<DeveloperAppReview>();
export const appCategoriesAdapter = createEntityAdapter<AppCategory>();
export const appsAdapter = createEntityAdapter<App>();
export const appVersionsAdapter = createEntityAdapter<AndroidVersion>();
export const serverFeatureAdapter = createEntityAdapter<ServerFeature>();
export const merchantPlanAdapter = createEntityAdapter<MerchantPlan>();

export const permissionAdapter = createEntityAdapter<AppMarketPermission>({
  selectId: (permission: AppMarketPermission): EntityId => {
    const { name } = permission;
    return name;
  }
});

export const suggestedAppsAdapter = createEntityAdapter<SuggestedApp>({
  selectId: (suggestedApp: SuggestedApp): EntityId => {
    const { app } = suggestedApp;
    return app.id;
  }
});
